/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

// Material UI table
import { MaterialReactTable } from "material-react-table";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import CompanyDetailsCommonHeader from "../CompanyDetailsCommonHeader/CompanyDetailsCommonHeader";
import ContractHeader from "./Header/ContractHeader";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import SaveContractPopup from "./Popup/SaveContractPopup";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import frequencyOptions from "data/Prod/FrequencyOptions.json";
import { mergeListById } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";

const ContractBody = () => {
  const { t, i18n } = useTranslation(); //for translation

  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const moduleAccess = localStorage.getItem("moduleaccess");

  const [isLoading, setIsLoading] = useState(false);
  const [contractList, setContractList] = useState([]);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedContractIds, setSelectedContractIds] = useState([]);
  const [selectedContractId, setSelectedContractId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  const [isCompanyModerator, setIsCompanyModerator] = useState(false);
  const [isDataReady, setIsDataReady] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const getCompanyDetails = async () => {
    try {
      setIsLoading(true);
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_COMPANY_DETAILS}/${params.id}?token=${token}&modulefrom=backend`;
      const response = await getData(requestUrl);

      console.log("response of company details------>", response);

      if (response.status && response.data) {
        let isModerator = false;
        if (
          response.data.moderator.toString() === userInfo._id.toString() ||
          userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN"
        ) {
          isModerator = true;
        }

        setIsCompanyModerator(isModerator);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  //function for get all contacts
  const getAllContractList = async () => {
    setRowSelection({});
    setSelectedContractIds([]);
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_COMPANY_CONTRACTS +
        `?token=${token}&company=${params.id}`;

      console.log("url of contract list------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in contract list------>", response);

      setIsLoading(false);
      if (response.status) {
        setContractList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for change status
  const deleteBulkHandler = async () => {
    if (selectedContractIds.length > 0) {
      try {
        const contractListToBeDelete = contractList.filter((item) =>
          selectedContractIds.includes(item._id)
        );

        let apiData = {
          contractlist: contractListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_COMPANY_CONTRACT +
          `?token=${token}`;

        const response = await putData(requestURL, apiData);

        // console.log("response in delete bulk member------>", response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setContractList((prevList) =>
              prevList.filter((item) => !selectedContractIds.includes(item._id))
            );
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select contract for delete");
    }
    setShowAlert(true);
  };

  //function for remove tag
  const removeTags = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_COMPANY_CONTRACT;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      // console.log("response in remove tag from lead------->", data);

      if (data) {
        afterActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedContractId(null);
      }, 1000);
    }
  };

  //function for after any action
  const afterActionClose = (data = []) => {
    setContractList((prevList) => mergeListById(prevList, data));
  };

  //material table columns array
  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Actions"),
      Cell: ({ row }) => {
        return (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveContract"
            aria-controls="saveContract"
            onClick={() => {
              setSelectedContractId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        );
      },
      enableColumnActions: false, // Hides the column action icon
      enableColumnDragging: false, // Hides the move icon
      enableSorting: false,
    },
    {
      accessorKey: "customid",
      header: t("Id"),
    },
    {
      accessorKey: "tagstring",
      header: t("Label"),
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.taglist.length > 0
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.taglist.map((tag, index) => (
                  <li key={index} className="d-inline-flex">
                    <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                      <span className="badge-text fs-xs fw-medium me-1">
                        {tag.title}
                      </span>
                      <Link
                        to="#"
                        className={`${
                          tag.moderator.toString() ===
                            userInfo._id.toString() ||
                          userInfo.role.slug === "ADMIN" ||
                          userInfo.role.slug === "SUPER_ADMIN"
                            ? "d-block"
                            : "d-none"
                        }`}
                        onClick={() => {
                          setSelectedContractId(row.original._id);
                          setSelectedTagId(tag._id);
                          removeTags([tag._id], row.original._id);
                        }}
                      >
                        {selectedTagId &&
                        selectedTagId === tag._id &&
                        selectedContractId &&
                        selectedContractId === row.original._id ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary ms-1"
                            role="status"
                            style={{ height: "12px", width: "12px" }}
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <span
                            className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                            style={{ cursor: "pointer" }}
                          >
                            cancel
                          </span>
                        )}
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
              style={{ width: "24px", height: "24px" }}
              data-bs-toggle="modal"
              data-bs-target="#addLabelModal"
              onClick={() => setSelectedContractIds([row.original._id])}
            >
              <span
                className="material-symbols-outlined text-primary"
                style={{ fontSize: "16px" }}
              >
                add
              </span>
            </button>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "providername",
      header: "Provider",
      Cell: ({ row }) => {
        return <p>{row.original.provider?.name}</p>;
      },
    },
    {
      accessorKey: "companytypename",
      header: "Company Type",
    },
    {
      accessorKey: "contracttype",
      header: "Contract Type",
    },
    {
      accessorKey: "contractstartdate",
      header: "Start Date",
    },
    {
      accessorKey: "contractenddate",
      header: "End Date",
    },
    {
      accessorKey: "amount",
      header: "Amount",
    },
    //frequency
    {
      accessorKey: "frequency",
      header: "Frequency",
      Cell: ({ row }) => {
        const frequencyData = frequencyOptions.find(
          (option) => option.value === row.original.frequency
        );
        return <p>{frequencyData?.label}</p>;
      },
    },
  ];

  //* Material React Table Column and States */
  const columns = useMemo(
    () => initialTableColumns,
    [contractList, selectedTagId, i18n.language]
  );

  //initialize the column order
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key] && key !== "0"
    );

    if (selectedIdsArray.length > 0) {
      setSelectedContractIds(selectedIdsArray);
    } else {
      setSelectedContractIds([]);
    }
  }, [rowSelection]);

  useEffect(() => {
    if (params.id) {
      const initializeData = async () => {
        await getCompanyDetails();
        await getAllContractList();
        setIsDataReady(true);
      };
      initializeData();
    }
  }, [params.id]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_COMPANY")
  ) {
    return (
      <div id="content_wrapper">
        <section className="event-details-wrapper bg-white pb-5">
          {/* ---- companies common header ---- */}
          {params.id && <CompanyDetailsCommonHeader moduleName="contracts" />}
          {isLoading || !isDataReady ? (
            <div className="container-fluid px-lg-5 pt-4 pt-md-4">
              <div className="table-wrapper">
                <LoadingSkeleton />
              </div>
            </div>
          ) : isCompanyModerator ? (
            <div className="container-fluid px-lg-5 pt-4 pt-md-0">
              {/* ------- filter area --------- */}
              <ContractHeader
                reloadList={getAllContractList}
                selectedContractIds={selectedContractIds}
              />

              {/* ------- list area ---------- */}

              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={contractList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection, columnOrder: initialColumnOrder }} //pass our managed row selection state to the table to use
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  enableStickyHeader
                />
              </div>
            </div>
          ) : (
            <AccessDeniedView />
          )}
        </section>

        {/* ---------- popups and modals area --------- */}
        <SaveContractPopup
          selectedContractId={selectedContractId}
          setSelectedContractId={setSelectedContractId}
          afterPopupClose={afterActionClose}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {/* --------- add label modal ------------ */}
        <AddLabelModal
          moduleName="contract"
          selectedIds={selectedContractIds}
          afterTagModalClose={afterActionClose}
          onModalClose={() => {
            setSelectedContractIds([]);
            setRowSelection({});
          }}
        />

        <DeleteWarningModal
          onCancelDelete={() => {
            setRowSelection({});
            setSelectedContractIds([]);
          }}
          onDelete={deleteBulkHandler}
          moduleName={t("contract")}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default ContractBody;
